import { useNavigate } from 'react-router-dom';
import UsersPage from '../../UsersPage';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function UsersContainer() {
  const navigate = useNavigate();
  const { org, currentUser } = useLegacyAppSession();

  return (
    <UsersPage
      organizationId={org?.id ?? null}
      organizationName={org?.name ?? ''}
      currentUser={currentUser}
      onAdd={() => navigate('/users/new')}
      onEdit={(user) => navigate(`/users/${user.id}/edit`, { state: { user } })}
    />
  );
}
